module.exports = __webpack_public_path__ + "4f87859c4d56d4cc38fbb5bdc337c30f.ico";